// Importing JS

// eslint-disable-next-line no-unused-vars
import { Tooltip, Dropdown } from "bootstrap";
// import datepickerInit from "../components/hotel-datepicker/hotel-datepicker";
import initHeaderModal from "../components/header/header-modal";
import initHeaderSearchModal from "../components/header/header-search-modal";
import initBookingBar from "../components/booking-bar/booking-bar";
import initKongressiTable from "../components/kongresi-table/kongresiTable";
import { initHeaderAnimation } from "../components/header/animations/header-master-animation";
import ctaWithIconInit from "../components/cta-with-icon/cta-with-icon";
import {
  swiperDrugiTipiSobInit,
  swiperOkolicaInit,
  swiperTestemonialsInit,
  swiperPaketiInAkcijeInit,
  swiperIpPonudbaInit,
  swiperPodrocjaInit,
  swiperVsebinskiIzpostavekInit,
  swiperDogodkiInit,
  swiperUspKarticeInit,
  swiperKongresiInSrecanjaInit,
} from "../components/swiper/swiper";
import { initAllFiltrableMaps } from "../components/google-maps/js/map-filtrable";
import ShrGlobalMapInit from "../components/google-maps/js/map-global";
import "simplebar";
import closeWarning from "../components/warning/warning";
import initListingFilter from "../components/filter/filter";
import initUspCarousel from "../components/usp-carousel/usp-carousel";
import scrollToLink from "../components/scroll-to-link/scroll-to-link";
import Youtube from "../components/youtube/youtube";
import togglePasswordInputEye from "../components/password-input/password-input";
/* import textAreaCounter from "../components/text-area-input/text-area-input"; */
/* import dropdownInput from "../components/dropdown-input/dropdown-input"; */
import initGallery from "../components/gallery-grid/gallery";
import initGallerySlider from "../components/gallery-slider/gallery-slider";
import initBookingCardSlider from "../components/booking-card/booking-card-carousel";
/* import textInput from "../components/text-input/text-input"; */
import checkboxes from "../components/checkboxes/checkboxes";
import scrollToTop from "../components/footer/footer";
import searchResultsInit from "../pages/search/rezultati-iskanja";
import showMore from "../components/show-more/show-more";
import initDatatables from "../components/datatable/datatable";
import sidebarNav from "../components/sidebar-nav/sidebar-nav";
import userPopupOpen from "../components/user-popup/user-popup";
import copyToClipboard from "../components/reservation-card/reservation-card";
import userLoginOpen from "../components/user-login/user-login";
import {
  initDropletsTransfer,
  initAmbasadorLogin,
  initLoadMoreQnA,
  initProfileActivation,
  initPasswordReset,
  initPasswordChange,
  initDataChange
} from "../components/ambasador/ambasador";
import initMultipleChoiceCustomFields from "../components/multiple-choice-form-input/multiple-choice-form-input";

scrollToLink();
ctaWithIconInit();
swiperDrugiTipiSobInit();
swiperOkolicaInit();
swiperPodrocjaInit();
swiperVsebinskiIzpostavekInit();
swiperTestemonialsInit();
swiperPaketiInAkcijeInit();
swiperIpPonudbaInit();
swiperDogodkiInit();
swiperUspKarticeInit();
swiperKongresiInSrecanjaInit();
showMore();
searchResultsInit();
togglePasswordInputEye();
/* textInput(); */
checkboxes();
/* dropdownInput(); */
/* textAreaCounter(); */
initHeaderModal();
initHeaderSearchModal();
initBookingBar();
initKongressiTable();
// datepickerInit();
ShrGlobalMapInit();
initAllFiltrableMaps();
closeWarning();
initListingFilter();
initUspCarousel();
initGallery();
initGallerySlider();
initBookingCardSlider();
scrollToTop();
initDatatables();
sidebarNav();
userPopupOpen();
copyToClipboard();
userLoginOpen();

initDropletsTransfer();
initAmbasadorLogin();
initLoadMoreQnA();
initProfileActivation();
initPasswordReset();
initPasswordChange();
initDataChange();
initMultipleChoiceCustomFields();

// youtube
const youtube = new Youtube(); // eslint-disable-line no-unused-vars

document.addEventListener("DOMContentLoaded", () => {
  initHeaderAnimation();
  //  Make tooltip available globally
  document.bootstrap = { tooltip: Tooltip };
});

window.shr = {
  utils: {
    getCookie: function getCookieUtil(name) {
      const nameEQ = `${name}=`;
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
  },
};

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
[...tooltipTriggerList].map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

const dropdownElementList = document.querySelectorAll(".dropdown-toggle");
[...dropdownElementList].map((dropdownToggleEl) => new Dropdown(dropdownToggleEl));
